import { Injectable, inject } from '@angular/core';
import { fhirR4 } from '@smile-cdr/fhirts';
import { environment } from 'src/environments/environment';
import { ParameterParserService } from './parameter-parser.service';
import { ContextService } from './context.service';
import { DataService } from 'src/app/services/data.service';
import { AppContext } from 'src/app/models/AppContext';
import { TranslateService } from '@ngx-translate/core';
import { ParserService } from '../services/parser.service';

@Injectable({
  providedIn: 'root',
})
export class QrPopulateService {
  private readonly contextService = inject(ContextService);
  private readonly dataService = inject(DataService);
  private readonly paramParser = inject(ParameterParserService);
  private readonly translate = inject(TranslateService);
  private readonly parser = inject(ParserService);

  async populate(
    qPackage: fhirR4.Bundle,
    appContext: AppContext,
  ): Promise<fhirR4.QuestionnaireResponse> {
    const params = await this.prepareForPopulate(qPackage, appContext);
    const payload = await this.dataService
      .post<fhirR4.QuestionnaireResponse>(
        params,
        environment.dtrBackend + 'Questionnaire/$populate',
      )
      .catch((e) => {
        console.log(e);
        throw new Error(this.translate.instant('Error.Prepopulate'));
      });
    this.logQRErrors(payload);
    return payload;
  }

  async prepareForPopulate(
    qPackage: fhirR4.Bundle,
    appContext: AppContext,
  ): Promise<fhirR4.Parameters> {
    const questionnaire = this.parser.getQuestionnaireFromPackage(qPackage);
    const cqfParams = this.paramParser.getCqfParams(questionnaire, qPackage);
    const coverageId = this.contextService.getCoverageId(appContext);
    const patient = this.contextService.getPatientReference(appContext);
    const state = await this.dataService.getSofState();
    return this.paramParser.createParameterForPopulate(
      questionnaire,
      appContext,
      cqfParams,
      coverageId,
      state,
      patient,
    );
  }

  async logQRErrors(payload: fhirR4.QuestionnaireResponse) {
    try {
      const errorParams =
        this.paramParser.createPopulateErrorLogParameters(payload);
      if (errorParams) {
        await this.dataService.post(errorParams, this.getLogEndpoint());
      }
    } catch (err) {
      console.log('Error calling $DTRLogQuestionnaireErrors.', err);
    }
  }

  getLogEndpoint(): string | undefined {
    const endpoint = this.contextService.paEndpoints.DTRQuestionnaireError;
    if (endpoint) return endpoint;
    else throw new Error('Log endpoint not found!');
  }
}
